module.exports = __webpack_public_path__ + "img/city.d5a383b9.svg";